import {getMapBoundsQueryKey} from '@/shared/lib/react-query/getMapBoundsQueryKey';
import queryClient from '@/shared/lib/react-query/queryClient';

import boostStore from '../model/store';

export async function resetBoosts() {
  await queryClient.cancelQueries({queryKey: getMapBoundsQueryKey()});
  await queryClient.invalidateQueries({
    queryKey: getMapBoundsQueryKey(),
  });
  boostStore.resetBoosts();
}
